'use strict';

bbw.directive.bbwTimeRemaining = ['$timeout', 'bbw.ServerTimeSvc', function($timeout, serverTimeSvc) {
    var DEFAULT_MAX = 3600;

    return {
        scope: {
            value: '=bbwTimeRemaining',
            server: '=',
            max: '='
        },
        template: '<span ng-show="remaining.visible">{:remaining.m:}:{:remaining.s:}</span>',
        link: function(scope, element) {
            var destroyed = false, timeout;
            var max = parseInt(scope.max);
            if (!(max > 1)) {
                max = DEFAULT_MAX;
            }

            scope.remaining = {visible: false};

            var schedule = function() {
                if (destroyed) {
                    return;
                }
                if (timeout) {
                    $timeout.cancel(timeout);
                }
                timeout = $timeout(updateRemaining, 1000);
            };

            var updateRemaining = function() {
                timeout = undefined;
                var untilSec = parseInt(scope.value);
                var remSec;
                var stop = true;
                if (!isNaN(untilSec)) {
                    if (scope.server) {
                        untilSec = serverTimeSvc.toClientTimestamp(untilSec);
                    }
                    var now = (+new Date) / 1000;
                    if (untilSec > now) {
                        remSec = Math.round(untilSec - now);
                    } else {
                        remSec = 0;
                    }
                }
                if (angular.isDefined(remSec)) {
                    if (remSec < 0) {
                        remSec = 0;
                    }
                    if (remSec >= max) {
                        stop = false;
                    } else {
                        scope.remaining.visible = true;
                        scope.remaining.m = Math.floor(remSec / 60);
                        var sec = '' + Math.round(remSec % 60);
                        if (sec.length == 1) {
                            sec = '0' + sec;
                        }
                        scope.remaining.s = sec;
                        schedule();
                        return;
                    }
                }
                scope.remaining.visible = false;
                if (!stop) {
                    schedule();
                }
            };

            var destroy = function() {
                if (destroyed) {
                    return;
                }
                destroyed = true;
                if (timeout) {
                    $timeout.cancel(timeout);
                    timeout = undefined;
                }
            };

            updateRemaining();

            scope.$watch('value', function(newValue, oldValue) {
                //noinspection JSValidateTypes
                if (newValue !== oldValue && angular.isUndefined(timeout)) {
                    schedule();
                }
            });

            scope.$on('$destroy', destroy);
            element.on('$destroy', destroy);
        }
    }
}];
